/**
 * WelcomeStep - First step of onboarding
 * PRD: PRD-onboarding-organisateur.md
 */

import React from 'react';
import { Button, Icon } from '../../../../pages/DesignSystem';

interface WelcomeStepProps {
  onContinue: () => void;
}

const WelcomeStep: React.FC<WelcomeStepProps> = ({ onContinue }) => {
  return (
    <div className="onboarding-step onboarding-step--welcome">
      {/* Illustration */}
      <div className="onboarding-step__illustration">
        <div className="onboarding-step__icon-wrapper">
          <Icon name="Sparkles" size={48} />
        </div>
      </div>

      {/* Content */}
      <div className="onboarding-step__content">
        <h1 className="onboarding-step__title">
          Welcome to What 2 Do! 🎉
        </h1>

        <p className="onboarding-step__description">
          Your events are about to reach every tourist nearby! ✨
        </p>

        <p className="onboarding-step__text">
          Travelers are already looking for local experiences—we make sure they find yours! 🗺️
          See exactly how many tourists discover your events — right from your dashboard!
        </p>

        <p className="onboarding-step__text">
          Quick setup, then you're ready to shine! 🤙
        </p>
      </div>

      {/* CTA */}
      <div className="onboarding-step__actions">
        <Button
          variant="primary"
          size="lg"
          onClick={onContinue}
          className="onboarding-step__cta"
        >
          Let's Go
          <Icon name="ArrowRight" size={18} />
        </Button>
      </div>
    </div>
  );
};

export default WelcomeStep;
